/**
 * Client-side email guard: the server `EmailAddress` shape (WHATWG local part and domain labels,
 * max 254 chars) narrowed to require a dotted domain. Everything this accepts, the server accepts;
 * the extra strictness only catches obvious typos earlier. The server remains the source of truth.
 */
export function isValidEmail(raw: string): boolean {
  const value = raw.trim();
  return (
    value.length <= 254 &&
    /^[a-z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+$/i.test(
      value,
    )
  );
}
